(function () {
  var preview = null;
  var activeBtn = null;
  var cache = {};

  function largerUrl(src) {
    return src.replace(/[?&]width=\d+/, function (m) {
      return m[0] === '?' ? '?width=300' : '&width=300';
    });
  }

  function preloadAll() {
    document.querySelectorAll('.product__color-swatch img').forEach(function (img) {
      var url = largerUrl(img.src);
      if (!cache[url]) {
        var i = new Image();
        i.src = url;
        cache[url] = i;
      }
    });
  }

  function createPreview() {
    preview = document.createElement('div');
    preview.className = 'saquito-swatch-preview';
    preview.innerHTML = '<img>';
    document.body.appendChild(preview);
  }

  function show(btn, img) {
    if (!preview) createPreview();
    preview.querySelector('img').src = largerUrl(img.src);
    preview.classList.add('is-visible');
    position(btn);
  }

  function hide() {
    if (preview) preview.classList.remove('is-visible');
    activeBtn = null;
  }

  function position(btn) {
    if (!preview) return;
    var rect = btn.getBoundingClientRect();
    var pw = preview.offsetWidth || 140;
    var ph = preview.offsetHeight || 140;
    var left = rect.left + rect.width / 2 - pw / 2;
    var top = rect.top - ph - 10;
    if (left < 8) left = 8;
    if (left + pw > window.innerWidth - 8) left = window.innerWidth - pw - 8;
    if (top < 8) top = rect.bottom + 10;
    preview.style.left = left + 'px';
    preview.style.top = top + 'px';
  }

  function init() {
    preloadAll();

    // Desktop: mouse
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest('.product__color-swatch');
      if (!btn) return;
      var img = btn.querySelector('img');
      if (!img) return;
      if (btn === activeBtn) return;
      activeBtn = btn;
      show(btn, img);
    });

    document.addEventListener('mouseout', function (e) {
      var btn = e.target.closest('.product__color-swatch');
      if (btn && btn === activeBtn) hide();
    });

    // Mobile: touch — show on touchstart, hide on touchend/touchcancel
    document.addEventListener('touchstart', function (e) {
      var btn = e.target.closest('.product__color-swatch');
      if (!btn) { hide(); return; }
      var img = btn.querySelector('img');
      if (!img) return;
      activeBtn = btn;
      show(btn, img);
    }, { passive: true });

    document.addEventListener('touchend', hide, { passive: true });
    document.addEventListener('touchcancel', hide, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();